import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { Customer, } from '../../classess/customer/customer';

import { GlobalFormats } from '../../classess/main/globalFormats';

import ServiceDocumentDetails from './ServiceDocumentDetails';

import {
    getProcessButtons, dataTableLanguaje, setDateTimeFormatGlobalString, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, getRolesType, settings, styles, getUserRoles, handleResponseMessageAsync, LoadingSection, awaitDelayAsync,
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { DigitizedDocument } from '../../classess/main/digitizedDocument';
import { RemoteConnectionService } from '../../services/remoteConnections/RemoteConnectionService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'RemoteConnectionEdit';

export default function RemoteConnectionEdit({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const isMount = useRef(true);
    const { type = '', id = 0 } = useParams();
    const [viewType] = useState(type === labels?.edit?.en?.toLowerCase() ?
        1 :
        (type === labels?.details?.en?.toLowerCase() ? 2 : 0));

    const [process, setProcess] = useState({
        showLoading: true,
        back: false,
        detail: false,
    });

    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;

    const dtDocumentInformationsId = 'dtDocumentInformations';
    const dtServiceDocumentsId = 'dtServiceDocuments';
    const [showData, setShowData] = useState(true);

    const controls = {
        buttons: {
            detail: {
                id: 'btnDetail',
                defaultClass: 'btn btn-outline-info shadow-sm font-weight-bold mx-1 px-4',
            },
            back: {
                id: 'btnBack',
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
            },
        },
        icons: {
            detail: {
                id: 'iconDetail',
                defaultClass: icons?.fasFa?.list,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
    };

    const urls = {
        back: `${backend?.urls?.remoteConnections}/`,
        notFound: `${backend?.urls?.notFound}`,
    };

    const brdFieldViewsObj = {
        status: {
            label: '',
            badget: '',
        },
        scheduledDate: {
            date: '',
            time: ''
        },
        executionDate: {
            date: '',
            time: ''
        },
        commentary: '',
    };
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        brdFieldViews: brdFieldViewsObj,
        languageObj: languageObj,
        dtServiceDocumentsId: dtServiceDocumentsId,
        dtServiceDocumentsRowId: 0,
        sdShowModal: false,
        serviceDocument: DigitizedDocument?.getClass({}, false),
        showModal: false,
        userRoles: userRoles,
    });
    const [dataInfo, setDataInfo] = useState({ id: 0, description: '', rowId: 0, type: 0, });
    const [customer, setCustomer] = useState(Customer?.getClass({}, false));
    const [serviceDocuments, setServiceDocuments] = useState([DigitizedDocument?.getClass({}, false)]);
    const btnDetailRef = useRef(null);
    //#endregion variables

    //#region methods
    //#region remoteconnection
    const getServiceDocumentEditDetail = async ({
        e = undefined,
        id = 0,
        description = '',
        rowId = 0,
        type = 2,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getServiceDocumentEditDetail';
        try {
            e?.preventDefault?.();

            setDataInfo({ id: id, description: description, rowId: rowId, type: type, });

            btnDetailRef?.current?.click();
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const showServiceDocumentDetail = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'showServiceDocumentDetail';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, detail: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            //#region set data
            setModalObj(prev => ({
                ...prev,
                serviceDocument: serviceDocuments?.find(({ type, number }) => type === dataInfo?.description && number === dataInfo?.id) || {},
                dtServiceDocumentsRowId: dataInfo?.rowId,
                type: dataInfo?.type,
                sdShowModal: true,
            }));
            //#endregion set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, showLoading: false, detail: false }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion remoteconnection

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            //#region variables
            let customerData = Customer?.getClass({}, false);
            let serviceDocumetsData = [DigitizedDocument?.getClass({}, false)];
            let documentInformationsData = [DigitizedDocument?.getClass({}, {})];
            //#endregion variables

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region check type (url)
            if (viewType !== 2) {
                window.location.href = urls.notFound;
                return;
            }
            //#endregion check type (url)

            if (auth?.isLoged({ subMethod: currentMethod })?.result || !userRoles?.isAnonymous) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region check role
                if (viewType === 1 && !userRoles?.isAdmin && !userRoles?.isAnalyst) {
                    response = getResponse({ type: 1 });
                    response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`;
                    response.urlGoTo = urls.back;
                    return;
                }
                //#endregion check role

                //#region get data (remoteconnection)
                response = await RemoteConnectionService.getById({
                    auth,
                    id,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    response.urlGoTo = urls.back;
                    return;
                }

                //#region set data
                customerData = response?.result?.customer || {};
                setCustomer(customerData);
                serviceDocumetsData = response?.result?.remoteConnections || {};
                setServiceDocuments(serviceDocumetsData);
                documentInformationsData = response?.result?.digitizedDocuments || [];
                //#endregion set data

                //#region check data
                if (isUndNullEmp({ data: customerData, subMethod: currentMethod })?.result) {
                    response = getResponse({ type: 1 });
                    response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}.`;
                    response.urlGoTo = urls.back;
                    return;
                }
                //#endregion check data
                //#endregion get data (remoteconnection)

                //#region set datatable
                if ((!isUndNullEmp({ data: serviceDocumetsData, subMethod: currentMethod })?.result && serviceDocumetsData.length > 0) ||
                    (!isUndNullEmp({ data: documentInformationsData, subMethod: currentMethod })?.result && documentInformationsData.length > 0)) {
                    response = setDataInDataTable({
                        data: serviceDocumetsData,
                        documentInformations: documentInformationsData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                window.location.href = urls.back;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.urlGoTo = urls.back;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const goToBack = async ({
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'goToBack';
        try {
            setProcess(prev => ({ ...prev, showLoading: true, back: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            window.location.href = urls.back;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, back: false }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region document informations
            $(`#${dtDocumentInformationsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.row[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.type?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.document?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.description?.[languageObj?.id], width: '65%', orderable: false, },
                    { title: labels?.file[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc'], [1, 'asc']],
                //order: [[0, 'desc'],],
                responsive: true,
                lengthChange: false,
                autoWidth: false,
                info: false,
                ordering: false,
                paging: false,
                searching: false,
            });
            //.buttons().container().appendTo(`#${dtServiceDocumentsId}_wrapper .col-md-6:eq(0)`);
            //#endregion document informations

            //#region datacenters
            $(`#${dtServiceDocumentsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: 'dateTime', width: '0%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.row[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.type?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.document?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.date?.[languageObj?.id], width: '10%', orderable: false, },
                    {
                        title: labels?.daysToExpire?.[languageObj?.id], className: 'text-center', width: '15%', orderable: false,
                        render: function (data, type, row) {
                            try {
                                let newData = '';
                                const remainingDays = parseInt(data);
                                if (remainingDays >= 15) {
                                    newData = `<span class='text-success'>${data}</span>`;
                                } else if (remainingDays < 15 && remainingDays >= 1) {
                                    newData = `<span class='text-warning'>${data}</span>`;
                                } else {
                                    newData = `<span class='text-danger'>${data}</span>`;
                                }
                                return newData;
                            } catch (ex) {
                                return ex?.message;
                            }
                        },
                    },
                    { title: labels?.commentary?.[languageObj?.id], width: '35%', orderable: false, },
                    { title: labels?.file[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc'], [1, 'asc']],
                order: [[0, 'asc'],],
                //ordering: false,
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtServiceDocumentsId}_wrapper .col-md-6:eq(0)`);
            //#endregion datacenters
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region variables
            let id_ = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            $(`#${dtServiceDocumentsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtServiceDocumentsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'details':
                            getServiceDocumentEditDetail({ e: e, id: parseInt(id_), description: description, rowId: rowId, type: 2, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        documentInformations = [],
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            //#region variables
            let rowData = [];
            let urlDocument = '';
            let modelDigitizedDocument = DigitizedDocument?.getClass({}, false);
            //#endregion variables

            //#region process
            //#region digitizeddocument (document informations)
            rowData = [];
            documentInformations.forEach((documentInformation) => {
                //#region variables
                modelDigitizedDocument = DigitizedDocument?.getClass(documentInformation, false);
                urlDocument = isUndNullEmp({ data: modelDigitizedDocument?.urlDownload, subMethod: currentMethod })?.result ?
                    `<img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfNoAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/>` :
                    `<a href='${modelDigitizedDocument?.urlDownload}' rel='noreferrer noopener' target='_blank'><img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/></a>`;
                //#endregion variables

                rowData.push([
                    modelDigitizedDocument?.rowNumber,
                    modelDigitizedDocument?.type,
                    modelDigitizedDocument?.numberStr,
                    modelDigitizedDocument?.description,
                    urlDocument,
                ]);
            });

            $(`#${dtDocumentInformationsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion digitizeddocument (document informations)

            //#region digitizeddocument (service documents)
            rowData = [];
            data.forEach((remoteConnection) => {
                //#region variables
                modelDigitizedDocument = DigitizedDocument?.getClass(remoteConnection, false);
                const dateTime = modelDigitizedDocument?.emisionDate;
                const emisionDate = setDateTimeFormatGlobalString({
                    date: dateTime,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const remainingDays = modelDigitizedDocument?.service?.remainingDays;
                urlDocument = isUndNullEmp({ data: modelDigitizedDocument?.urlDownload, subMethod: currentMethod })?.result ?
                    `<img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfNoAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/>` :
                    `<a href='${modelDigitizedDocument?.urlDownload}' rel='noreferrer noopener' target='_blank'><img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/></a>`;
                const processButtons = [];
                //#endregion variables

                rowData.push([
                    dateTime,
                    modelDigitizedDocument?.rowNumber,
                    modelDigitizedDocument?.type,
                    modelDigitizedDocument?.numberStr,
                    emisionDate,
                    remainingDays,
                    modelDigitizedDocument?.description,
                    urlDocument,
                    getProcessButtons({
                        id: modelDigitizedDocument?.number,
                        description: modelDigitizedDocument?.type,
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: false,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtServiceDocumentsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion digitizeddocument (service documents)
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.services?.services}
                process={app?.views?.remoteConnections?.remoteConnections} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={urls.back}>{labels?.remoteConnections?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt='remoteConnections' style={styles?.cardHeaderLogo} src={images?.icons?.remoteConnections} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.remoteConnections?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.laptop} mr-1`}></i> {labels?.details?.[languageObj?.id] || 'Details'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <div className='row'>
                                                    {/* Customer Detail Card */}
                                                    <div className='col-12 col-md-6 mb-3'>
                                                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100'
                                                            style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                style={html?.labels?.detailMicro}>
                                                                <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.customer?.[languageObj?.id]}
                                                            </small>
                                                            <span className='text-dark font-weight-bold'>{`${customer?.rif || ''} ${customer?.name || ''}` || '---'}</span>
                                                        </div>
                                                    </div>

                                                    {/* Service Status Detail Card */}
                                                    <div className='col-12 col-md-6 mb-3'>
                                                        <div className={`p-3 rounded bg-light border-left border-${serviceDocuments?.length > 0 ? 'success' : 'secondary'} shadow-sm h-100`}
                                                            style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                style={html?.labels?.detailMicro}>
                                                                <i className={`${icons?.fasFa?.server} mr-1`} /> {labels?.service?.[languageObj?.id]}
                                                            </small>
                                                            <div className='d-flex align-items-center'>
                                                                <span className='text-dark font-weight-bold mr-2'>
                                                                    {serviceDocuments?.length > 0 ? labels?.isActive?.[languageObj?.id] : labels?.inActive?.[languageObj?.id] || 'Inactive'}
                                                                </span>
                                                                {serviceDocuments?.length > 0 ? (
                                                                    <i className={`${icons?.fasFa?.checkCircle} text-success`} />
                                                                ) : (
                                                                    <i className={`${icons?.fasFa?.timesCircle} text-secondary`} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.fileAlt} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.documentInformations?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtDocumentInformationsId} languageObj={languageObj} />

                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.folderOpen} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.serviceDocuments?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtServiceDocumentsId} languageObj={languageObj} />
                                            </div>

                                            <div className='card-footer border-top-0 pb-4 px-4 bg-white'>
                                                <div className='d-flex flex-wrap justify-content-end align-items-center'
                                                    style={{ gap: '8px' }}>
                                                    <button id={controls?.buttons?.detail?.id}
                                                        ref={btnDetailRef}
                                                        className={controls?.buttons?.detail?.defaultClass}
                                                        disabled={process?.showLoading}
                                                        hidden
                                                        style={{ borderRadius: '5px' }}
                                                        type='button'
                                                        onClick={(e) => showServiceDocumentDetail({ e: e, subMethod: e?.currentTarget?.id, })}>
                                                        {!process?.detail ? (
                                                            <i id={controls?.icons?.detail?.id} className={controls?.icons?.detail?.defaultClass} />
                                                        ) : (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        )} {labels?.detail?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.defaultClass}
                                                        disabled={process?.showLoading}
                                                        style={{ borderRadius: '5px' }}
                                                        type='button'
                                                        onClick={() => goToBack({ subMethod: controls?.buttons?.back?.id })}>
                                                        {!process?.back ? (
                                                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.defaultClass} />
                                                        ) : (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        )} {labels?.back?.[languageObj?.id]}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>

            </div>

            {modalObj?.sdShowModal && (
                <ServiceDocumentDetails modalObj={modalObj}
                    setModalObj={setModalObj} />
            )}
        </div>
    )
}